import React from 'react';
/**
 * WidgetRSPSvg — Icône du phidget Résolution de Problèmes
 * Design System SEIZO : ampoule + engrenage
 */
const WidgetRSPSvg = ({ width = 20, height = 20, couleur = "#A8B0B3" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
        {/* Ampoule */}
        <path
            d="M10 2C7.23858 2 5 4.23858 5 7C5 8.74565 5.9 10.2793 7.25 11.1667V13H12.75V11.1667C14.1 10.2793 15 8.74565 15 7C15 4.23858 12.7614 2 10 2Z"
            stroke={couleur} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
        />
        {/* Base ampoule */}
        <path d="M7.5 13H12.5" stroke={couleur} strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M8 15H12" stroke={couleur} strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M9 17H11" stroke={couleur} strokeWidth="1.5" strokeLinecap="round"/>
        {/* Rayon gauche */}
        <path d="M3.5 7H2" stroke={couleur} strokeWidth="1.5" strokeLinecap="round"/>
        {/* Rayon droit */}
        <path d="M18 7H16.5" stroke={couleur} strokeWidth="1.5" strokeLinecap="round"/>
        {/* Rayon haut-gauche */}
        <path d="M5.05 3.05L4 2" stroke={couleur} strokeWidth="1.5" strokeLinecap="round"/>
        {/* Rayon haut-droit */}
        <path d="M14.95 3.05L16 2" stroke={couleur} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
);
export default WidgetRSPSvg;
